<template>
<div
    v-if="props.type == 'message' "
    class="v-input__details v-messages v-input--error text-error m-2 mt-0 pt-0"
    style="opacity: 1;"
    role="alert">
    {{ getErrors[0] }}
</div>
    
<v-alert
    v-else-if="props.type == 'alert' && getErrors.length > 0"
    :key="getErrors"
    border="start"
    closable
    :title="$t('label.error')"
    :icon="false"
    variant="tonal"
    type="error">
    <ol v-if="props.multiMessage">
        <li v-for="(error,index) in getErrors" :key="error">{{ (index+1) +'. '+ error }}</li>
    </ol>
    <span v-else>{{ getErrors[0] }}</span>
</v-alert>
</template>
           
<script setup>
import { useErrorStore } from '@/stores/error';
import { computed, watch } from 'vue';
    
const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    value: {
        type: null,
        required: true,
    },
    errorMessage: {
        type: String,
        default: '',
    },
    type: {
        type: String,
        default: 'message', // message|alert
    },
    multiMessage: {
        type: Boolean,
        default: false,
    },
});
        
const errorStore = useErrorStore();
const getErrors = computed(() => {
    if (props.errorMessage) {
        return [props.errorMessage];
    }
    return errorStore.all[props.name] || [];
});
    
watch(() => props.value, () => {
    errorStore.remove(props.name);
}, { deep: true });
    
</script>
    
